import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ImageService {
  constructor() {}

  getImageStyle = (imageWidth?: number) => {
    if (!imageWidth || !Number.isFinite(imageWidth) || imageWidth <= 0) {
      return "width:auto;max-width:100%;height:auto;";
    }
    return `width:${imageWidth}px;max-width:min(100%,${imageWidth}px);height:auto;`;
  };
}
